import * as yup from "yup";

export const passwordChangeSchema = yup.object().shape({
  password: yup
    .string()
    .required("Password is required")
    .min(4, "Password must be at least 4 characters")
    .max(20, "Password must be at most 20 characters"),
  passwordConfirmation: yup
    .string()
    .required("Password confirmation is required")
    .test({
      name: "address",
      message: "Invalid wallet address.",
      test: (value, context) => {
        if (context?.parent?.password !== value) {
          return context.createError({ message: "Passwords must match" });
        }
        return true;
      },
    }),
});

export const authSchema = yup.object().shape({
  firstName: yup.string().required().min(2).max(20),
  lastName: yup.string().required().min(2).max(20),
  email: yup.string().required().email(),
});

export const signInSchema = yup.object().shape({
  email: yup.string().required().email(),
  password: yup.string().required().min(4),
});

export const twoFactorSchema = yup.object().shape({
  twoFactorAuthenticationCode: yup.string().required().min(6).max(6),
});
